import React, { useState } from "react";
import { useMemo, useEffect } from "react";
import styled from "styled-components";
import { useTable, usePagination } from "react-table";
import { BsCheckLg, BsX, BsPencil, BsTrash } from "react-icons/bs";
import deleteIcon from "../../../assets/svgIcons/delete-icon.svg";
import editIcon from "../../../assets/svgIcons/edit.svg";
import editlight from "../../../assets/svgIcons/editLight-icon.svg";

import { toast } from "react-toastify";
import Swal from "sweetalert2";
import dayjs from "dayjs";

const EditableTable = ({
  columns,
  data,
  setData,
  handleButtonClick,
  updateRecruiterFun,
}: any) => {
  const totalRecruiterLists = data.length;
  const {
    getTableProps,
    headerGroups,
    getTableBodyProps,
    rows,
    page,
    prepareRow,
    state: { pageIndex, pageSize },
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    pageCount,
    pageOptions,
    setPageSize,
  }: any = useTable({ columns, data }, usePagination);

  const headerColors = ["#fff2cd", "#ededed", "#e1efd8"];
//   const columnColors: Record<string, string> = {
//     "Month, Year": "#fff2cd",
//     "": "#fff2cd",
//     "Job Offers": "#ededed",
//     Issued: "#ededed",
//     Accepted: "#ededed",
//     Declined: "#ededed",
//     Candidates: "#e1efd8",
//     "Total Engaged": "#e1efd8",
//     Joined: "#e1efd8",
//     Dropouts: "#e1efd8",
//   };

  return (
    <div>
      <table {...getTableProps()}>
        <thead>
          {headerGroups?.map((headerGroup: any) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup?.headers.map((column: any) => (
                <th
                  className={`sm-text text-secondary text-center`}
                  {...column?.getHeaderProps()}
                //   style={{ backgroundColor: columnColors[column.Header] }}
                  rowSpan={column.rowspan}
                >
                  {column?.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page?.map((row: any) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell: any, idx: number) => {
                  if (cell.column.editEnable) {
                    if (
                      cell.column.id === "$recruiterRemark" &&
                      row.original.isEditing
                    ) {
                      return (
                        <td key={idx} {...cell.getCellProps}>
                          <div className={`d-flex align-items-center`}>
                            <textarea
                              defaultValue={cell.value}
                              className="sm-text flex-grow-1"
                              //   onChange={(e) =>
                              //     handleInputChange(e, row, cell.column.id)
                              //   }
                            />

                            <div
                              className="py-1"
                              onClick={() => {
                                updateRecruiterFun(row.original);
                              }}
                            >
                              <BsCheckLg
                                className="mx-2"
                                color={"#002c71"}
                                size={20}
                              />
                            </div>
                            <div
                              className="py-1"
                              onClick={() => {
                                handleButtonClick("cancel", row.original);
                              }}
                            >
                              <BsX className="mx-2" color="#D92D20" size={20} />
                            </div>
                          </div>
                        </td>
                      );
                    }
                    if (cell.column.id === "$recruiterStatus") {
                      return (
                        <td key={idx} {...cell.getCellProps}>
                          <select
                            className="sm-text"
                            defaultValue={cell.value}
                            // id={cell.value}
                            disabled={!row.original.isEditing}
                            // onChange={(e) =>
                            //   handleInputChange(e, row, cell.column.id)
                            // }
                          >
                            <option className="sm-text" value={"New"}>
                              New
                            </option>
                            <option className="sm-text" value={"In Progress"}>
                              In Progress
                            </option>
                            <option className="sm-text" value={"Complete"}>
                              Completed
                            </option>
                          </select>
                        </td>
                      );
                    }

                    return (
                      <td key={idx} {...cell.getCellProps} className="sm-text">
                        {cell.render("Cell")}
                      </td>
                    );
                  }
                  return (
                    <td key={idx} {...cell.getCellProps}>
                      <p className="sm-text text-end">{cell.render("Cell")}</p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* <div className="d-flex align-items-center mt-3">
        <button
          style={{ width: 35 }}
          className="sbmit_btn_outline ms-2"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <label>{"<"}</label>
        </button>{" "}
        <button
          style={{ width: 35 }}
          className="sbmit_btn_outline ms-2"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          <label>{">"}</label>
        </button>{" "}
        <span className="ms-2">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
      </div> */}
    </div>
  );
};

// ===========================================================
function HrActionTable({ dataIs, dataLength, onDeleteRow }: any) {
  const columnsData = [
    {
      Header: "Month, Year",
      columns: [{Header: "", accessor: "Month" }],
    },
    {
      Header: "Job Offers",
      columns: [
        {
          Header: "Issued",
          accessor: "Issued",
        },
        {
          Header: "Accepted",
          accessor: "Accepted",
        },
        {
          Header: "Declined",
          accessor: "Declined",
        },
      ],
    },
    {
      Header: "Candidates",
      columns: [
        {
          Header: "Total Engaged",
          accessor: "Total_Engaged",
        },
        {
          Header: "Joined",
          accessor: "Joined",
        },
        {
          Header: "Dropouts",
          accessor: "Dropouts",
        },
      ],
    },
  ];

  const [data, setdata] = useState<any>([]);

  const onDeleteRecruiter = async (id: number) => {
    try {
      // const res = await deleteRecruiterByIdReq({ id });
      // toast.success(res?.message);
      // onDeleteRow({ id });
    } catch (error: any) {
      console.log(error, "error in onDeleteRecruiter");
      if (error?.errorCode + "" === "403") {
        Swal.fire({
          icon: "warning",
          text: error?.errorMsg,
        });
        return;
      }
      toast.error(error?.errorMsg);
    }
  };

  useEffect(() => {
    setdata(dataIs ? dataIs : []);
  }, [dataIs]);

  return (
    <CustomeTable className="w-100">
      <EditableTable
        columns={columnsData}
        data={data}
        setData={setdata}
        // handleButtonClick={handleButtonClick}
        // updateRecruiterFun={updateRecruiterFun}
      />
    </CustomeTable>
  );
}

export default HrActionTable;

const CustomeTable = styled.table`
  table {
    width: 100%;
    select {
      border: none;
      color: #9a9a9a;
    }
    textarea {
      border-radius: 5px;
      border: 1px solid #c6c6c6;
      text-align: start;
      color: #9a9a9a;
      width: 150px;
      min-height: 40px;
      margin: 5px 0px;
      padding: 4px;
    }
    thead th {
      font-size: small;
      //   color: #9a9a9a;
      font-weight: 400;
      text-transform: capitalize;
      padding: 10px 5px;
      border-right: 1px solid #ccc;
    }
    thead th:first-child {
      border-top: none;
      text-align: center;
    }
    thead th:last-child {
      border-right: none;
    }

    td {
      font-size: 12px;
      padding: 5px 5px;
      //   color: #9a9a9a;
      //   border: 1px solid rgb(227, 227, 227);
      border-right: 1px solid #ccc;
    }
    td:last-child {
      border-right: none;
    }
    tr {
      border-bottom: 1px solid rgb(227, 227, 227);
    }
    tbody tr:last-child {
      border-bottom: none;
    }
    td:nth-of-type(1),
    th:nth-of-type(1) {
      padding-left: 15px;
    }
    td:nth-of-type(2) {
      color: rgb(0, 0, 0) !important;
      font-size: 14px;
      font-weight: 400;
    }
    /* Center alignment for Job Offers and Candidates headers */
    th[colspan="3"] {
      text-align: center;
    }
    td[colspan="3"] {
      text-align: end;
    }
  }
`;
